<template>
    <div>
        <div class="title-box">
            空气洁净度明细
        </div>
        <!-- 查询条件 -->
        <el-form id="formID" :inline="true" :model="queryParams" style="border-radius:3px;margin-bottom:10px; box-shadow:0px 1px 0px 0px rgba(0, 0, 0, 0.1);" class="demo-form-inline">
            <el-row>
                <el-form-item>
                    <el-select ref="factorySelect" v-model="queryParams.factoryId" filterable placeholder="选择工厂" clearable @change="getWorkshopByFactory">
                        <el-option
                        v-for="item in factoryOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select ref="workshopSelect" v-model="queryParams.workshopId" filterable clearable placeholder="选择车间" @change="getSceneByWorkshop">
                        <el-option
                        v-for="item in workshopOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select ref="sceneSelect" placeholder="选择场景" v-model="queryParams.sceneId" clearable filterable @change="getNumByScene">
                        <el-option
                        v-for="item in sceneOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="queryParams.devNum" placeholder="设备编号" clearable filterable>
                    <el-option v-for="dNum in deviceNumList" :key="dNum.id" :label="dNum.name" :value="dNum.name" />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-date-picker v-model="queryParams.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始时间" clearable></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-date-picker v-model="queryParams.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="结束时间" clearable></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" @click="onReset">重置</el-button>
                </el-form-item>

                <!-- 表格/图表切换 -->
                <el-form-item style="float:right;">
                    <span @click="changeData(1)" :class="['tool-icon',{'select-icon': showTable}]" title="表格">
                        <img src="@/assets/images/table.png"/>
                    </span>
                    <span @click="changeData(2)" :class="['tool-icon',{'select-icon': !showTable}]" title="图表">
                        <img src="@/assets/images/chart.png"/>
                    </span>
                    <span v-hasPermi="['enterpr:airclean:export']" title="导出" @click="exportData()" class="tool-icon">
                        <img src="@/assets/images/download.png"/>
                    </span>
                </el-form-item>
            </el-row>
        </el-form>
        <div v-show="showTable">
            <!-- 表格 -->
            <el-table :data="tableData" border :style="{ height: tableHeight + 'px',width:'100%','border-radius':'3px'}" class="custom-table-header">
                <el-table-column type="index" label="序号" width="100" align="center"></el-table-column>
                <el-table-column prop="factoryName" label="工厂" align="center"></el-table-column>
                <el-table-column prop="workshopName" label="车间" align="center"></el-table-column>
                <el-table-column prop="sceneName" label="场景" align="center"></el-table-column>
                <el-table-column prop="sourceTime" label="时间" align="center"></el-table-column>
                <el-table-column prop="pc1" label="0.3μm粒子数" width="100" align="center"></el-table-column>
                <el-table-column prop="pc2" label="0.5μm粒子数" align="center"></el-table-column>
                <el-table-column prop="pc3" label="1μm粒子数" align="center"></el-table-column>
                <el-table-column prop="pc4" label="3μm粒子数" width="100" align="center"></el-table-column>
                <el-table-column prop="pc5" label="5μm粒子数" align="center"></el-table-column>
                <el-table-column prop="pc6" label="10μm粒子数" align="center"></el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="block" style="background:#fff;text-align:center;padding:20px 0;">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryParams.pageNum"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="queryParams.pageSize"
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <div v-show="!showTable">
            <div id="lineDiv" :style="{ height: (tableHeight+72) + 'px',width:'100%','border-radius':'3px',background:'#fff'}"></div>
        </div>
    </div>
</template>
<script>
import { formatDate, formatDateTime, compareDates, isWithinOneMonth } from '@/utils/base';
import * as echarts from 'echarts';
import { Message } from 'element-ui';
import {download} from '@/utils/request';
export default {
    data(){
        return{
            // 查询条件
            queryParams: {
                pageNum:1,
                pageSize: 10,
                factoryId:"",
                workshopId:"",
                sceneId:"",
                devNum:"",
                startTime:"",
                endTime:""
            },
            showTable:true,
            //工厂数据
            factoryOptions: [],
            // 车间数据
            workshopOptions:[],
            sceneOptions:[],
            deviceNumList:[],
            total:0,
            tableHeight:650,
            // 表格数据
            tableData:[],
            lineChart:null,
            sourceTime:[],
            data1:[],
            data2:[],
            data3:[],
            data4:[],
            data5:[],
            data6:[],
            pc03AlarmVal:null,//0.5标准
            pc05AlarmVal:null//0.3标准
        }
    },
    mounted() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
        let eDate = formatDateTime(new Date());
        let sDate = formatDate(new Date());
        this.queryParams.endTime = eDate;
        this.queryParams.startTime = sDate+" 00:00:00";
        this.getFactoryByCustomer();
    },
    methods: {
        // 监听窗口缩放
        handleResize(){
            // 当窗口大小变化时，这个函数会被调用
            const height = window.innerHeight;
            // 你可以在这里添加你的处理代码
            let dom = document.getElementById("formID");
            let formH = 70;//一行时高度为70
            if(dom){
                formH = dom.offsetHeight;
            }
            this.tableHeight = height-190-formH;//表单的高度会变化

            // 设置表格体高度
            let tableBody = document.getElementsByClassName("el-table__body-wrapper")[0];
            if(tableBody){
                tableBody.style.height = (this.tableHeight-40)+"px";
            }

            if(this.lineChart){
                this.lineChart.resize();
            }
        },
        // 查询
        onSubmit() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        // 重置
        onReset(){
            let eDate = formatDateTime(new Date());
            let sDate = formatDate(new Date());
            this.queryParams = {
                pageNum:1,
                pageSize: 10,
                factoryId:"",
                workshopId:"",
                sceneId:"",
                devNum:"",
                startTime:sDate+" 00:00:00",
                endTime:eDate
            };
            this.tableData = [];
            this.sourceTime = [];
            this.data1 = [];
            this.data2 = [];
            this.data3 = [];
            this.data4 = [];
            this.data5 = [];
            this.data6 = [];
            this.pc03AlarmVal = null;
            this.pc05AlarmVal = null;
        },
        handleSizeChange(val) {
            this.queryParams.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.getList();
        },
        // 根据客户查询工厂
        getFactoryByCustomer(){
            this.$store.dispatch("workshop/getFactoryByCustomer").then((result)=>{
                this.factoryOptions = result.data;
            });
        },
        // 根据工厂查询车间
        getWorkshopByFactory(val){
            if(!val){
                this.queryParams.workshopId = null;
                this.workshopOptions = [];
                this.queryParams.sceneId = null;
                this.sceneOptions = [];
                this.queryParams.devNum = null;
                this.deviceNumList = [];
                return;
            }
            this.$store.dispatch("scene/getWorkshopByFactory",{factoryId:val}).then((result)=>{
                this.queryParams.workshopId = null;
                if(result&& result.data&& result.data.length>0){
                    this.workshopOptions = result.data;
                }
                else{
                    this.workshopOptions = [];
                }
            });
        },
        // 根据车间查询场景
        getSceneByWorkshop(val){
            if(!val){
                this.queryParams.sceneId = null;
                this.sceneOptions = [];
                this.queryParams.devNum = null;
                this.deviceNumList = [];
                return;
            }
            this.$store.dispatch("monitorData/getSceneByWorkshop",{workshopId:val}).then((result)=>{
                this.queryParams.sceneId = null;
                if(result&& result.data&& result.data.length>0){
                    this.sceneOptions = result.data;
                }
                else{
                    this.sceneOptions = [];
                }
            });
        },
        // 根据场景查询设备编码
        getNumByScene(val){
            if(!val){
                this.queryParams.devNum = null;
                this.deviceNumList = [];
                return;
            }
            this.$store.dispatch("monitorData/getDeviceByScene",{sceneId:val,deviceName:'空气粒子计数器'}).then((result)=>{
                this.queryParams.devNum = null;
                if(result&& result.data&& result.data.length>0){
                    this.deviceNumList = result.data;
                }
                else{
                    this.deviceNumList = [];
                }
            });
        },
        getList(){
            if(compareDates(this.queryParams.startTime,this.queryParams.endTime)){
                Message.warning('截止日期不能早于开始日期！');
                return;
            }
            if(isWithinOneMonth(new Date(this.queryParams.startTime), new Date(this.queryParams.endTime), 31)){
                Message.warning('日期范围不能超过31天！');
                return;
            }
            if(!this.queryParams.devNum){
                Message.warning('请先选择设备编号！');
                return;
            }
            let factoryName = this.$refs.factorySelect.selected.label;
            let workshopName = this.$refs.workshopSelect.selected.label;
            let sceneName = this.$refs.sceneSelect.selected.label;
            if(this.showTable){//表格
                this.$store.dispatch('monitorData/getAirPcHistoryPage', this.queryParams).then((result)=>{
                if(result?.rows){
                    this.tableData = result.rows;
                    this.total = result.total;
                    for(let i=0;i<this.tableData.length;i++){
                        this.tableData[i].factoryName = factoryName;
                        this.tableData[i].workshopName = workshopName;
                        this.tableData[i].sceneName = sceneName;
                    }
                }
                else{
                    this.tableData = [];
                    this.total = 0;
                }
            }); 
            }
            else{//曲线
                this.$store.dispatch('monitorData/getAirPcHistory', this.queryParams).then((result)=>{
                    if(result?.data?.values){
                        let values = result?.data?.values;
                        this.pc03AlarmVal = result?.data?.pc03AlarmVal;//0.5标准
                        this.pc05AlarmVal = result?.data?.pc05AlarmVal;//0.3标准
                        this.sourceTime = [];
                        this.data1 = [];
                        this.data2 = [];
                        this.data3 = [];
                        this.data4 = [];
                        this.data5 = [];
                        this.data6 = [];
                        for(let i=0;i<values.length;i++){
                            this.sourceTime.push(values[i].sourceTime);
                            this.data1.push(values[i].pc1);
                            this.data2.push(values[i].pc2);
                            this.data3.push(values[i].pc3);
                            this.data4.push(values[i].pc4);
                            this.data5.push(values[i].pc5);
                            this.data6.push(values[i].pc6);
                        }
                    }
                    else{
                        this.standard = null;
                        this.sourceTime = [];
                        this.data1 = [];
                        this.data2 = [];
                        this.data3 = [];
                        this.data4 = [];
                        this.data5 = [];
                        this.data6 = [];
                        this.pc03AlarmVal = null;
                        this.pc05AlarmVal = null;
                    }
                    this.initLine(); 
                }); 
            }
        },
        initLine(){
            var chartDom = document.getElementById('lineDiv');
            this.lineChart = echarts.init(chartDom);
            var option = {
                color:["#00DB0F","#00E48D","#06E9E0","#4BBEFF","#3083FB","#5C5EE9"],
                tooltip : {
                    trigger: 'axis'
                },
                legend: {
                    left: "170",
                    top:"28",
                    data:['10μm','5μm','3μm','1μm','0.5μm','0.3μm']
                },
                grid:{
                    left:100
                },
                xAxis : [
                    {
                        type : 'category',
                        boundaryGap : false,
                        splitLine: {
                            show: true
                        },
                        axisLine: {
                            lineStyle:{
                                color:"#BFBFBF"
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel : {
                            color:"#666666"
                        },
                        data : this.sourceTime
                    }
                ],
                yAxis : [
                    {
                        name:"粒子数",
                        nameTextStyle: {
                            color: "#666666"
                        },
                        type : 'value',
                        min:0,
                        axisLine: {
                            show: true,
                            lineStyle:{
                                color:"#BFBFBF"
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel : {
                            color:"#666666"
                        }
                    }
                ],
                visualMap:[],
                series : [
                    {
                        name:'0.3μm',
                        type:'line',
                        data:this.data1,
                        markLine: {
                            silent: true,
                            lineStyle: {
                                color: '#0f0'
                            },
                            data: []
                        },
                        yAxisIndex: 0 // 使用第一个yAxis（即主Y轴）
                    },
                    {
                        name:'0.5μm',
                        type:'line',
                        data:this.data2,
                        markLine: {
                            silent: true,
                            lineStyle: {
                                color: '#00f'
                            },
                            data: []
                        },
                        yAxisIndex: 0
                    },
                    {
                        name:'1μm',
                        type:'line',
                        data:this.data3
                    },
                    {
                        name:'3μm',
                        type:'line',
                        data:this.data4
                    },
                    {
                        name:'5μm',
                        type:'line',
                        data:this.data5
                    },
                    {
                        name:'10μm',
                        type:'line',
                        data:this.data6
                    }
                ]
            };
            if(this.pc03AlarmVal){
                option.visualMap.push({
                    show:false,
                    pieces: [
                        {
                            gt: 0,
                            lte: this.pc03AlarmVal,
                            color: '#00DB0F'
                        },
                        { gt: this.pc03AlarmVal, color: 'red' }
                    ],
                    seriesIndex:0
                })
                option.series[0].markLine.data.push({ yAxis: this.pc03AlarmVal })
            }
            if(this.pc05AlarmVal){
               option.visualMap.push({
                    show:false,
                    pieces: [
                        {
                            gt: 0,
                            lte: this.pc05AlarmVal,
                            color: '#00E48D'
                        },
                        { gt: this.pc05AlarmVal, color: 'red' }
                    ],
                    seriesIndex:1
                }) 
                option.series[1].markLine.data.push({ yAxis: this.pc05AlarmVal })
            }
            option && this.lineChart.setOption(option);      
        },
        // 表格/曲线切换
        changeData(data){
            if(data == 2){//曲线
                this.showTable = false;
            }
            else{
                this.showTable = true;
                this.lineChart = null;
            }
            this.getList();
        },
        // 导出
        exportData(){
            download('/biz/airPcHistory/export',
            {
                devNum: this.queryParams.devNum,
                startTime: this.queryParams.startTime,
                endTime: this.queryParams.endTime
            },
            `空气洁净度查询_${new Date().getTime()}.xlsx`)
        }
    }
}
</script>

<style lang="scss" scoped>
    .title-box{
        width: 100%;
        font-size: 16px;
        font-weight: bold;
        padding: 27px 0 15px;
        line-height: 16px;
    }
    // 表头背景色
    ::v-deep .custom-table-header th{
        background-color: #ebeef5 !important;
    }
    // 表格字体大小
    .el-table {
        font-size: 12px;
    }
    // 表单底部边界线
    .el-table::before {
        height: 0px;
    }
    // 表格字体
    ::v-deep .el-table thead {
        color: #606266;
    }
    // 表格内边距
    ::v-deep .el-table .el-table__cell {
        padding: 8px 0;
    }
    // 表单底部margin
    .el-form-item {
        margin-bottom: 0;
    }
    // 当前页码样式
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #FF9F07;
    }
    // 页面hover样式
    .el-pagination.is-background .el-pager li:not(.disabled):hover {
        color: #FF9F07;
    }
    // .el-button{
    //     font-size: 12px;
    // }
    ::v-deep .el-form-item__label {
        font-size: 12px;
    }
    ::v-deep .el-table__body-wrapper{
        height: 100%;
        overflow-y: auto;
    }
    .tool-icon{
        width:28px;
        height:32px;
        cursor:pointer;
        background:#C7C7C7;
        display:inline-block;
        vertical-align:middle;
        text-align:center;
        border-radius:4px;
        margin-left:5px;
    }
    .select-icon{
        background:#3083FB;
    }
</style>